<div>
  <span class="k-event-title">{{ log.event }}</span>
  <a
    class="view-audit"
    [routerLink]="['/admin/app/seguridad/auditoria']"
    [queryParams]="{ event: log.id }"
    target="_blank"
    aria-label="Ver auditoría"
    title="Ver auditoría"
  >
    <i class="ph ph-magnifying-glass-plus"></i>
  </a>
</div>
<div kendoCardSubtitle>
  <p class="subtitle">
    <span>Actualizado por: </span>
    <span class="context" appDefaultValue>
      {{ log.updatedByUser }}
    </span>
  </p>
</div>
